module.exports = __webpack_public_path__ + "nc_static/media/dd_system_configuration.f38a628a.svg";